export const generalStore = (() => {
    let state = {
        currentReferencesSlide: 0,
        navOpen: false,
        currentLink: null,
        windowWidth: 0,
        navState: 'desktop'
    };

    const subscribers = new Set();

    function subscribe(callback) {
        subscribers.add(callback);

        if (callback.length === 2) {
            callback(state, state);
        } else {
            callback(state);
        }

        return () => subscribers.delete(callback);
    }

    function setState(newState) {
        const prevState = { ...state };
        state = { ...state, ...newState };

        subscribers.forEach(cb => {
            if (cb.length === 2) {
                cb(state, prevState);
            } else {
                cb(state);
            }
        });
    }

    function toggleNav() {
        setState({ navOpen: !state.navOpen });
    }

    function watch(key, callback) {
        return subscribe((newState, oldState) => {
            if (newState[key] !== oldState[key]) {
                callback(newState[key], oldState[key]);
            }
        });
    }

    return {
        subscribe,
        setState,
        toggleNav,
        watch,
        get state() {
            return state;
        }
    };
})();
